import React from "react";
import "../styles/Section.css";

const Hero = () => {

  const smoothScroll = (id) => {
    const target = document.getElementById(id);
    const offset = 70; // adjust for navbar height
    const top = target.offsetTop - offset;

    window.scrollTo({
      top,
      behavior: "smooth"
    });
  };

  return (
    <section id="home" className="hero">
      <h1>Building Scalable Digital Products</h1>
      <p>
        We design, develop, and deploy modern software solutions that drive
        measurable business growth.
      </p>

      <div className="hero-buttons">
        <button
          className="cta"
          onClick={() => smoothScroll("cases")}
        >
          View Our Work
        </button>

        <button
          className="cta secondary"
          onClick={() => smoothScroll("contact")}
        >
          Get Consultation
        </button>
      </div>
    </section>
  );
};

export default Hero;